<div class="tag-container" fxLayout="column" data-cy="tag-component-tag">
  <div fxLayout="row nowrap" fxLayoutAlign="start center" fxLayoutGap="20px">
    <span><p ellipsis>{{ text }}</p></span>
    <i class="fal fa-times" (click)="onDelete()" *ngIf="!hideIcon && !loading && canManage" data-cy="tag-component-close-tag"></i>
    <i class="fas fa-circle-notch fa-spin" *ngIf="loading"></i>
  </div>
</div>
